import angular from 'angular';
import SimpleTableDirective from './simple-table.directive';

const SimpleTableModule = angular
    .module('control-room.commons.data.components.simple-table', [])
    .directive('crSimpleTable', SimpleTableDirective.directiveFactory);

export default SimpleTableModule;
